// A direct purchase unlocks this web version as well as the desktop app. The
// fulfilment email links here with a signed token in the URL hash
// (infra/lambda/stripe-webhook/unlock.mjs). The token is verified against this
// public key and kept in localStorage, so the unlock lasts in this browser.
// ECDSA P-256 rather than Ed25519: every browser with WebCrypto verifies it,
// including Chromebooks stuck on an old Chrome.

PUBLIC_KEY: JsonWebKey :=
  kty: "EC"
  crv: "P-256"
  x: "WPUwv4OIMF4ldbKGNGFZMjyGCtuJGsetf7BqB3Xbxw8"
  y: "ToiYjlt3pn5WkxEz2gSLt6AOz2JwPUUHREuQWRCq20o"

HASH_PREFIX := "#unlock="
STORAGE_KEY := "unlockToken"

base64urlBytes := (s: string) ->
  binary := atob s.replace(/-/g, "+").replace(/_/g, "/")
  Uint8Array.from binary, (c) -> c.charCodeAt 0

// True when token is a correctly signed unlock token.
export verifyUnlock := (token: string, key: JsonWebKey = PUBLIC_KEY): Promise<boolean> ->
  parts := token.split "."
  return false unless parts.length is 2
  [payload, signature] := parts

  try
    k := await crypto.subtle.importKey "jwk", key, { name: "ECDSA", namedCurve: "P-256" }, false, ["verify"]
    return await crypto.subtle.verify { name: "ECDSA", hash: "SHA-256" }, k, base64urlBytes(signature), new TextEncoder().encode(payload)
  catch
    return false

// Takes an unlock token off the URL, so it neither stays in the address bar
// nor gets read as a song slug (persistence.civet loads the hash on startup).
// Call before the player is constructed.
export takeUnlockToken := ->
  return unless location.hash.startsWith HASH_PREFIX
  token := location.hash.slice HASH_PREFIX.length
  history.replaceState null, "", location.pathname + location.search
  return token

// "new": the link's token verified and is now stored. "stored": a token kept
// from an earlier visit verified. "invalid": the link's token did not verify
// and nothing stored does. undefined: no token anywhere.
export checkUnlock := (fresh?: string, key: JsonWebKey = PUBLIC_KEY): Promise<"new" | "stored" | "invalid" | undefined> ->
  if fresh and await verifyUnlock fresh, key
    try localStorage.setItem STORAGE_KEY, fresh
    return "new"

  stored := try localStorage.getItem STORAGE_KEY
  if stored and await verifyUnlock stored, key
    return "stored"

  return "invalid" if fresh
  return
